<script setup lang="ts">
import { PaymentMethod } from "@/model/payment/payment-method"
import { defineTranslations } from "@/utils/defineTranslations"

defineProps<{
    methods: PaymentMethod[]
}>()

const model = defineModel<PaymentMethod | null>()

const trans = defineTranslations({
    "title": {
        de: "Zahlart wählen",
        en: "Choose payment method",
    },
    "method.BankTransfer": {
        de: "Banküberweisung",
        en: "Bank Transfer",
    },
    "method.Paypal": {
        de: "PayPal",
        en: "PayPal",
    },
    "method.CreditCard": {
        de: "Kreditkarte",
        en: "Credit Card",
    },
    "method.ApplePay": {
        de: "Apple Pay",
        en: "Apple Pay",
    },
    "method.GooglePay": {
        de: "Google Pay",
        en: "Google Pay",
    },
    "method.PayByBank": {
        de: "Sofortüberweisung",
        en: "Pay by Bank",
    },
})

function label(method: PaymentMethod) {
    switch (method) {
        case PaymentMethod.BankTransfer:
            return trans("method.BankTransfer")
        case PaymentMethod.Paypal:
            return trans("method.Paypal")
        case PaymentMethod.CreditCard:
            return trans("method.CreditCard")
        case PaymentMethod.ApplePay:
            return trans("method.ApplePay")
        case PaymentMethod.GooglePay:
            return trans("method.GooglePay")
        case PaymentMethod.PayByBank:
            return trans("method.PayByBank")
        default:
            return method
    }
}
</script>
<template>
    <div>
        <b>{{ trans("title") }}</b>
        <div class="list-group rounded mt-2">
            <label
                v-for="method in methods"
                :key="method"
                class="list-group-item d-flex align-items-center mb-0"
                :class="{ active: model === method }"
                style="cursor: pointer"
            >
                <input
                    class="mr-3"
                    type="radio"
                    :value="method"
                    :checked="model === method"
                    @change="model = method"
                />
                {{ label(method) }}
            </label>
        </div>
    </div>
</template>
